import React from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import QueryClientProvider from "./modules/shared/libs/@tanstack/react-query/QueryClientProvider";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <QueryClientProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>,
);

reportWebVitals();
